import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';
import { Close as CloseIcon, WarningAmber } from '@mui/icons-material';
import { useTranslate } from 'react-admin';

interface Props {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const UpdateTemplatifyKeyConfirmDialog: React.FC<Props> = ({
  open,
  onConfirm,
  onCancel,
}) => {
  const translate = useTranslate();

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason === 'backdropClick') return;
        onCancel();
      }}
      maxWidth="sm"
      fullWidth
    >
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 1, pt: 1 }}>
        <IconButton onClick={onCancel} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
            textAlign: 'center',
            pb: 2,
          }}
        >
          <WarningAmber sx={{ fontSize: 48, color: 'warning.main' }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {translate(
              'resources.accounts.templatify.updateApiKey.confirmTitle'
            )}
          </Typography>
          <Typography color="text.secondary">
            {translate(
              'resources.accounts.templatify.updateApiKey.confirmMessage'
            )}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'center',
          pb: 3,
          gap: 1,
          flexDirection: { xs: 'column-reverse', sm: 'row' },
          px: { xs: 2, sm: 3 },
        }}
      >
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          size="medium"
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            width: { xs: '100%', sm: '12.5rem' },
            height: '2.75rem',
          }}
        >
          {translate('resources.accounts.templatify.updateApiKey.confirmYes')}
        </Button>
        <Button
          onClick={onCancel}
          variant="contained"
          color="primary"
          size="medium"
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            width: { xs: '100%', sm: '12.5rem' },
            height: '2.75rem',
          }}
        >
          {translate('resources.accounts.templatify.updateApiKey.confirmNo')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateTemplatifyKeyConfirmDialog;
